/* RESPONSIBLE TEAM: team-ai-agent */
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import { ReactRoute } from 'embercom/lib/react-route';
import type ReactTeammateAppIslandService from 'embercom/services/react-teammate-app-island';
import type KnowledgeHubDrawerEditorService from 'embercom/services/knowledge-hub-drawer-editor-service';
import type AppService from 'embercom/services/app-service';
import type RouterService from '@ember/routing/router-service';

export class AskIndexRoute extends Route {
  @service declare reactTeammateAppIsland: ReactTeammateAppIslandService;
  @service declare knowledgeHubDrawerEditorService: KnowledgeHubDrawerEditorService;
  @service declare appService: AppService;
  @service declare router: RouterService;

  private unsubscribeKnowledgeHub?: () => void;

  beforeModel() {
    if (!this.appService.app.canUseFeature('team-rec-internal-agent')) {
      this.router.transitionTo('apps.app');
    }
  }

  reactEnabled() {
    return true;
  }

  activate() {
    // Subscribe to knowledge-hub:open-content events from React
    this.unsubscribeKnowledgeHub = this.reactTeammateAppIsland.subscribeToTeammateAppEvent(
      'knowledge-hub:open-content',
      (data: Record<string, unknown>) => {
        let contentId = data.contentId as number | string;
        let contentType = data.contentType as string;
        let editorMode = (data.editorMode as string) || 'view';

        // Open the drawer on the current route (no navigation)
        if (editorMode === 'view') {
          this.knowledgeHubDrawerEditorService.openViewDrawer({
            activeContentId: contentId,
            activeContentType: contentType,
            newTab: false,
          });
        } else {
          this.knowledgeHubDrawerEditorService.openEditDrawer({
            activeContentId: contentId,
            activeContentType: contentType,
            newTab: false,
          });
        }
      },
    );
  }

  deactivate() {
    // Clean up subscription when leaving the route
    if (this.unsubscribeKnowledgeHub) {
      this.unsubscribeKnowledgeHub();
      this.unsubscribeKnowledgeHub = undefined;
    }
  }
}

export default ReactRoute(AskIndexRoute);
